import React, { useState } from 'react';
import './App.css';
import HomePage from './components/HomePage';
import ShowElements from './components/ShowElements';
import CharacteristicsPage from './components/CharacteristicsPage';
import Versus from './components/Versus';
import Fight from './components/Fight/Fight';
import PointsUI from "./components/PointsUI/PointsUI";
import { Switch, Route } from 'react-router-dom';

function App() {

  const [choosedPokemon, setChoosedPokemon] = useState(null);
  const [allPokemons, setAllPokemons] = useState(null);
  const [opponents, setOpponents] = useState(null);
  const [playerPoints, setPlayerPoints] = useState(window.localStorage.getItem("points") || 0);

  return (
    <div>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/show-elements">
          <ShowElements choosePokemon={setChoosedPokemon} setAllPokemons={setAllPokemons} playerPoints={playerPoints} />
        </Route>
        <Route path="/characteristics-page">
          { choosedPokemon &&  <CharacteristicsPage name={choosedPokemon.name} types={choosedPokemon.types} 
          height={choosedPokemon.height} weight={choosedPokemon.weight} index={choosedPokemon.id} playerPoints={playerPoints} /> }
        </Route>
        <Route path="/versus">
          { choosedPokemon && <Versus name={choosedPokemon.name} pokemons={allPokemons} setOpponents={setOpponents} /> }
        </Route>
        <Route path="/fight">
			    {opponents && <Fight opponents={opponents} setPlayerPoints={setPlayerPoints} />}
		</Route>
      </Switch>
    </div>
  );
}

export default App;